import * as _ from "lodash";
import { User } from "./user.model";
import { HouseOccupant } from "./house-occupant.model";
import { House } from "./house.model";

export class Appointment {
    public id?: number | string;
    public name: string;
    public description?: string;
    public status?: string = "Active";
    public timestamp?: string;
    public creationdatetime?: string;
    public lastmodifieddatetime?: string;
    public appointmenttime?: Date;
    public uid: number | string;
    public hoid?: number | string;
    public hid?: number | string;
    public csid?: number | string;
    public creator?: number | string;
    public lastupdater?: number | string;
    public groupdate?: string;
    public assignee?: User;
    public canvass?: any;
    public contact?: HouseOccupant;
    public house?: House;

    private modelsUtils: any;

    constructor(ModelsUtils: any, data?: object) {
        this.modelsUtils = ModelsUtils;

        if (data) {
            this.setData(data);
        }
    }

    getID(): string | number {
        return this.id;
    }

    isComplete(): boolean {
        return this.status == "Done";
    }

    isToday(): boolean {
        return (
            new Date(this.appointmenttime) == new Date() && !this.isComplete()
        );
    }

    isOverdue(): boolean {
        const now = new Date();
        return new Date(this.appointmenttime) < now && !this.isComplete();
    }

    statusText(): string {
        if (this.isComplete()) {
            return "Complete";
        } else if (this.isOverdue()) {
            return "Overdue";
        } else {
            return "To Do";
        }
    }

    setData(data: object): void {
        if (!!data["assignee"]) {
            this.assignee = this.modelsUtils.user(data["assignee"]);
            if (!this.uid) this.uid = this.assignee.uid;
        }
        if (!!data["house"]) {
            this.house = this.modelsUtils.house(data["house"]);
            if (!this.hid) this.hid = this.house.hid;
        }
        if (!!data["contact"]) {
            this.contact = this.modelsUtils.houseOccupant(data["contact"]);
            if (!this.hoid) this.hoid = this.contact.hoid;
        }
        _.merge(this, data);
    }

    getData(): object {
        return {
            uid: this.assignee.uid ?? this.uid,
            assignee: this.assignee,
            hid: this.hid,
            hoid: this.hoid,
            appointmenttime: this.appointmenttime,
            name: this.name,
            description: this.description,
        };
    }
}
